import React from 'react';
import { useFieldAttributes } from '../../../services/field-attributes';
import { DateFieldWUT } from '../../../ui/date-field';
import { getDatePartsErrors } from '../../../ui/date-field/date-field-utils';
import { FieldDescriptionWUT } from '../../../ui/field-description/field-description-wut';
import { FieldLabelWUT } from '../../../ui/field-label/field-label-wut';
import { FieldErrorWUT } from '../../../ui/field-error/field-error-wut';
export const DateInputWUT = _ref => {
  let {
    id,
    description,
    target,
    value,
    error,
    hasError = false,
    errorMessage,
    required,
    label,
    hideLabel,
    onBlur,
    onFocus,
    onChange,
    disabled,
    hidePlaceholder,
    showDateLabels,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    FieldLayout
  } = _ref;
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }),
    renderInput: () => /*#__PURE__*/React.createElement(DateFieldWUT, {
      onBlur: onBlur,
      onChange: onChange,
      onFocus: onFocus,
      inputId: inputId,
      ariaLabelledBy: labelId,
      value: value ?? '',
      id: id,
      disabled: disabled,
      errors: getDatePartsErrors(hasError, value ?? ''),
      hidePlaceholder: hidePlaceholder,
      showDateLabels: showDateLabels,
      required: required,
      ariaDescribedBy: ariaDescribedBy
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
};
//# sourceMappingURL=date-input-wut.js.map